import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Activer tous les cookies (ex. : Google Analytics)
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
    // Désactiver les cookies non nécessaires
  };

  if (!showBanner) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: 'rgba(255, 255, 255, 0.9)', // Fond blanc semi-transparent
        p: 3, // Plus de padding pour un design aéré
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 1000,
        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography
        sx={{
          mb: { xs: 2, md: 0 },
          color: '#333', // Meilleur contraste
          fontSize: '1rem', // Taille de police augmentée
          maxWidth: '800px', // Limite la largeur du texte
        }}
      >
        Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et personnaliser le contenu. Voir notre{' '}
          politique de confidentialité pour plus d'informations.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mt: { xs: 2, md: 0 } }}>
        <Button
          onClick={handleDecline}
          variant="outlined"
          sx={{
            color: '#34495e',
            borderColor: '#34495e',
            fontSize: '1rem',
            padding: '8px 16px', // Boutons plus grands
          }}
        >
          Refuser les non essentiels
        </Button>
        <Button
          variant="contained"
          onClick={handleAcceptAll}
          sx={{
            bgcolor: '#34495e',
            color: '#fff',
            fontSize: '1rem',
            padding: '8px 16px',
          }}
        >
          Tout accepter
        </Button>
      </Box>
    </Box>
  );
};

export default CookieConsent;